module.exports = __webpack_public_path__ + "img/home-nav-icon-07.5bd3c2ec.png";